import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../../components/ui/button';
import { User, Shield, Bell, PaintBrush, Database } from '@phosphor-icons/react';

const SettingsPage = () => {
  const { user, logout } = useAuth();

  const roleLabels = {
    pi: 'Principal Investigator',
    researcher: 'Researcher',
    student: 'Student',
    admin: 'Administrator'
  };

  return (
    <div data-testid="settings-page">
      <div className="mb-6">
        <h1 className="heading-display">Settings</h1>
        <p className="text-zinc-500 mt-1">Manage your account and preferences</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Profile Section */}
        <div className="lg:col-span-2 space-y-6">
          <div className="card-flat p-6">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-blue-100 text-indigo-400 rounded-sm flex items-center justify-center text-2xl font-bold">
                {user?.name?.charAt(0)?.toUpperCase() || 'U'}
              </div>
              <div>
                <h2 className="heading-card">{user?.name}</h2>
                <p className="text-sm text-zinc-500">{user?.email}</p>
                <span className="text-xs bg-blue-100 text-indigo-400 px-2 py-0.5 rounded-sm mt-1 inline-block">
                  {roleLabels[user?.role] || user?.role}
                </span>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 bg-zinc-50 rounded-sm">
                <div className="flex items-center gap-3">
                  <User size={20} className="text-zinc-500" />
                  <div>
                    <p className="text-sm font-medium">Account Information</p>
                    <p className="text-xs text-zinc-500">Member since {new Date(user?.created_at).toLocaleDateString()}</p>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between p-4 bg-zinc-50 rounded-sm">
                <div className="flex items-center gap-3">
                  <Shield size={20} className="text-zinc-500" />
                  <div>
                    <p className="text-sm font-medium">Security</p>
                    <p className="text-xs text-zinc-500">Password and authentication settings</p>
                  </div>
                </div>
                <Button variant="outline" size="sm" className="btn-secondary" disabled>
                  Coming Soon
                </Button>
              </div>

              <div className="flex items-center justify-between p-4 bg-zinc-50 rounded-sm">
                <div className="flex items-center gap-3">
                  <Bell size={20} className="text-zinc-500" />
                  <div>
                    <p className="text-sm font-medium">Notifications</p>
                    <p className="text-xs text-zinc-500">Email and alert preferences</p>
                  </div>
                </div>
                <Button variant="outline" size="sm" className="btn-secondary" disabled>
                  Coming Soon
                </Button>
              </div>
            </div>
          </div>

          {/* Data Management */}
          <div className="card-flat p-6">
            <h3 className="heading-card mb-4 flex items-center gap-2">
              <Database size={20} /> Data Management
            </h3>
            <p className="text-sm text-zinc-500 mb-4">
              Export your lab data or manage integrations
            </p>
            <div className="flex gap-2">
              <Button variant="outline" className="btn-secondary" disabled>
                Export All Data
              </Button>
              <Button variant="outline" className="btn-secondary" disabled>
                Connect Google Drive
              </Button>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="space-y-6">
          {/* Quick Stats */}
          <div className="card-flat p-6">
            <h3 className="heading-card mb-4">Your Activity</h3>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between">
                <span className="text-zinc-500">Experiments</span>
                <span className="font-medium">-</span>
              </div>
              <div className="flex justify-between">
                <span className="text-zinc-500">Protocols</span>
                <span className="font-medium">-</span>
              </div>
              <div className="flex justify-between">
                <span className="text-zinc-500">Plasmids</span>
                <span className="font-medium">-</span>
              </div>
            </div>
          </div>

          {/* Danger Zone */}
          <div className="card-flat p-6 border-red-800/40">
            <h3 className="heading-card text-red-400 mb-4">Danger Zone</h3>
            <p className="text-sm text-zinc-500 mb-4">
              Irreversible actions for your account
            </p>
            <Button
              variant="destructive"
              className="w-full bg-red-600 text-white hover:bg-red-700"
              onClick={logout}
              data-testid="logout-settings-btn"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
